import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

const generateFn = httpsCallable(functions, 'propertyMarketingGenerateDraft');
const translateFn = httpsCallable(functions, 'propertyMarketingTranslateHtml');

/**
 * @param {{ propertyId: string, locale?: string, instructionHtml?: string }} params
 *   instructionHtml — HTML from the in-app editor; used as creative direction for generation.
 * @returns {Promise<{ html: string }>}
 */
export async function propertyMarketingGenerateDraft(params) {
  const { data } = await generateFn(params);
  return data;
}

/**
 * @param {{ html: string, targetLang: 'fr' | 'en' }} params
 * @returns {Promise<{ html: string }>}
 */
export async function propertyMarketingTranslateHtml(params) {
  const { data } = await translateFn(params);
  return data;
}
